import { BaseBoxShapeTool } from "@tldraw/tldraw";
export class CommentShapeTool extends BaseBoxShapeTool {
  static override id = "comment";
  static override initial = "idle";
  override shapeType = "comment";
}
